import { lazy } from 'react';
import Loadable from 'components/Loadable';
import CommonLayout from 'layout/CommonLayout';

const MaintenanceError = Loadable(lazy(() => import('pages/maintenance/error/404')));
const MaintenanceError500 = Loadable(lazy(() => import('pages/maintenance/error/500')));

const MaintenanceRoutes = {
  path: '/maintenance',
  element: <CommonLayout />,
  children: [
    { path: '404', element: <MaintenanceError /> },
    { path: '500', element: <MaintenanceError500 /> },
  ],
};

export default MaintenanceRoutes;
